// extracted by mini-css-extract-plugin
export default {"card_container":"TrendsBlogCard_card_container__pHtuk","card_img":"TrendsBlogCard_card_img__kc9ca","card_content":"TrendsBlogCard_card_content__NbQfL"};